<div class="datepicker">
  <form [formGroup]="formGroup" novalidate>
    <zaver-form-input
      [title]="title"
      [placeholder]="placeholder"
      [errorMessage]="getErrorMessage()"
      [error]="formGroup.controls[formName].invalid && showError"
      [size]="'large'"
      (input)="onDateInputChange()"
      [formControlName]="formName"
      [maxLength]="10"
      [showContent]="true"
      [hideLabelsMobile]="false"
      [disabled]="isDisabled"
      >
      <app-zaver-icon [size]="24" name="calendar" (click)="onClickSelect()"></app-zaver-icon>
    </zaver-form-input>
  </form>


  <button (click)="onClickSelect()" type="button">
    <app-zaver-icon [size]="8" name="chevronDown" ></app-zaver-icon>
  </button>

  <div *ngIf="showCalendar">
    <app-datepicker-calendar
      #CalendarComponent
      class="calendar"
      [(date)]="dueDate"
      [closeCalendar]="closeCalendar"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [resetDateForm]="clearForm"
      [isDateResettable]="isDateResettable"
      [resetButtonText]="resetButtonText"
      (dateChange)="onDateChange($event)"
    >
    </app-datepicker-calendar>
    <div class="calendar-background" (click)="closeCalendar()"></div>
  </div>
</div>
